import { angularService } from '@utils/angularBridge';

export const getApiEndpoint = (module: string) => {
    const zStatus = angularService('zStatus');

    // if (module === 'host') {
    //   return `https://host.${zStatus.api}`;
    // }

    const URL: string = zStatus && zStatus.endpoint && zStatus.endpoint[module] ? zStatus.endpoint[module] : null;

    return URL;
};

export const getBaseUrl = () => {
    return getApiEndpoint('de');
};

export const getModelUrl = () => {
    return getApiEndpoint('models');
};

export const getFunctionUrl = () => {
    return getApiEndpoint('functions');
};

export const getHostUrl = () => {
    return getApiEndpoint('host');
};

export const getDebuggerUrl = () => {
    return getApiEndpoint('debugger');
};

export const getAuthUrl = () => {
    return getApiEndpoint('auth');
};

export const getReportApiUrl = () => {
    return getApiEndpoint('report-list').replace(/\/$/gi, '');
};

export const apiError = (error: any) => {
    console.warn(error, 'error');

    return { error: parseErrorMessage(error) };
};

export const parseErrorMessage = (error: any) => {
    return error
        ? error?.response?.data?.error || error?.message || (typeof error === 'string' && error) || 'Unknown error'
        : undefined;
};

const getStatusCode = (error: any) => error?.response?.status || error?.status;

export const parseErrorStatus = (error: any) => {
    const zNetworkInterceptorService = angularService('zNetworkInterceptorService');

    return error
        ? error?.response?.statusText || error?.statusText || zNetworkInterceptorService.getStatus(getStatusCode(error))
        : undefined;
};

export const buildErrorDetails = (error: any) => {
    if (error?.status && error?.message) {
        // is error-like object
        return error;
    }

    const status = parseErrorStatus(error);
    const message = status ? parseErrorMessage(error) : error?.config?.url;

    return {
        statusCode: getStatusCode(error) || 500,
        status: status || 'Service is not available',
        message: message,
    };
};

export const capitalize = (name: string) => name.charAt(0).toUpperCase() + name.slice(1);

export const deCapitalize = (name: string) => name.charAt(0).toLowerCase() + name.slice(1);

export const normalizeName = (name: string) => {
    return name.split('_').map(capitalize).join('');
};

export const createIdName = (name: string) =>
    name
        .split(' ')
        .map((chunk: string) => capitalize(chunk))
        .join('');

export function getAuthHeader() {
    const key = Object.keys(sessionStorage).find((el) => el.includes('oidc.user'));
    const session = key && sessionStorage.getItem(key);
    if (!session) {
        return {};
    }

    const token = JSON.parse(session);
    return { Authorization: `${token.token_type} ${token.access_token}` };
}

export const lowerCaseProperties = (obj: { [key: string]: any }) => {
    if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach((name) => {
            const value = obj[name];
            delete obj[name];
            obj[deCapitalize(name)] = lowerCaseProperties(value);
        });
    }

    return obj;
};
